import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  {
    path: '/shop',
    name: 'Shop',
    component: () => import('../views/ShopView.vue')
  },
  {
    path: '/contact',
    name: 'Contact',
    component: () => import('../views/ContactView.vue')
  },
  {
    path: '/cars',
    name: 'Cars',
    component: () => import('../views/CarRent.vue')
  },
  {
    path: '/houses',
    name: 'Houses',
    component: () => import('../views/HouseRent.vue')
  },
  {
    path: '/shop-details',
    name: 'ShopDetails',
    component: () => import('../views/ShopDetails.vue')
  },
  {
    path: '/shopping-cart',
    name: 'CartView',
    component: () => import('../views/CartView.vue')
  },
  {
    path: '/cart-checkout',
    name: 'CartCheckout',
    component: () => import('../views/CartCheckout.vue')
  },
  {
    path: '/teams',
    name: 'TeamsView',
    component: () => import('../views/TeamsView.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
